<template>
	<section>
		<p class="f-20 f-m-14">
			<strong>Shipment</strong>
			<span class="title-date">{{ date | moment("dddd, DD MMMM YYYY")}}</span>
		</p>
		<div class="row">
			<router-link to="/shipment" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/shipment_complete.png" alt=""/>{{ model.status_pengiriman.done }}
					<button class="ml-2 info success">Selesai Diterima</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Pengiriman selesai diterima</p>
			</router-link>
			<router-link to="/shipment" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/shipment_otw.png" alt=""/>{{ model.status_pengiriman.sending }}
					<button class="ml-2 info infoo">Dalam Pengiriman</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Dalam Pengiriman</p>
			</router-link>
		</div>
		<div class="row">
			<router-link to="/shipment" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/shipment_waitingpickup.png" alt=""/>{{ model.status_pengiriman.wait }}
					<button class="ml-2 info primary">Menunggu Pickup</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Pengiriman menunggu pickup</p>
			</router-link>
			<router-link to="/shipment" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/shipment_inprocess.png" alt=""/>{{ model.status_pengiriman.on_process }}
					<button class="ml-2 info warning">Dalam Proses</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Pengiriman dalam proses</p>
			</router-link>
		</div>
		<p class="mt-5 f-20 f-m-14">
			<strong>Kendaraan</strong>
			<span class="title-date">{{ date | moment("dddd, DD MMMM YYYY")}}</span>
		</p>
		<div class="row">
			<router-link to="/expedition" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/vehicle_otw.png" alt=""/>{{ model.status_kendaraan.otw }}
					<button class="ml-2 info infoo">Dalam Perjalanan</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Kendaraan dalam perjalanan</p>
			</router-link>
			<router-link to="/expedition" class="col cole">
				<p class="info-box">
					<img class="img-mw-5" style="max-width: 50px;" src="img/icon-3/vehicle_complete.png" alt=""/>{{ model.status_perjalanan.done }}
					<button class="ml-2 info success">Selesai Diterima</button>
				</p>
				<p class="f-14 c-grey ml-4 mb-0">Kendaraan selesai mengirim dan diterima</p>
			</router-link>
		</div>
		<img src="img/group-311.png" alt="Bisa Cek" class="mt-5 hide-on-mobile" style="width: 13%">
	</section>
</template>

<script>
export default {
	name: 'Home',
	data(){
		return{
			model: {
				status_pengiriman: {},
				status_kendaraan: {},
				status_perjalanan: {}
			},
			date: new Date()
		}
	},
	methods:{
		get() {
			let _ = this
			_.axios.get('/dashboard').then(resp=>{
				_.model = resp.data.data    
			})
			.catch(err=>{
				console.log(err.message)
			})
		}
	},
	created(){
		let _ = this
		_.get()
	}
}
</script>